import { Button, Card, Modal, Table, TableProps } from 'antd';
import { FormatDate } from '../../../../../../constants';
import React from 'react';
import { JsonView, allExpanded } from 'react-json-view-lite';
import { SendReportCaseV1CaseHistory } from '../../../../../../generated';
import { Helmet } from 'react-helmet';

interface CaseHistoryProps {
  data: any;
  isCaseOrApplicant: string;
}

export const CaseHistory: React.FC<CaseHistoryProps> = (props) => {
  const [modalVisible, setModalVisible] = React.useState(false);
  const [data, setData] = React.useState<SendReportCaseV1CaseHistory | null>(null);
  const sortedLogs = [...(props.data?.caseHistory ?? [])].sort((a, b) => new Date(b?.createdAt).getTime() - new Date(a?.createdAt).getTime());

  const columns: TableProps<SendReportCaseV1CaseHistory>['columns'] = [
    {
      title: 'Created At',
      dataIndex: 'createdAt',
      key: 'createdAt',
      render: (text: any) => <span>{FormatDate(text)}</span>,
      sorter: (a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
    },
    {
      title: 'Action',
      key: 'action',
      render: (_text: any, record: any) => (
        <Button type="primary" onClick={() => handleView(record)}>
          View
        </Button>
      )
    }
  ];

  const handleView = (record: any) => {
    console.log('🚀 ~ handleView ~ record:', record);
    setModalVisible(true);
    setData(record);
  };

  const HistoryTable: React.FC<{ data: SendReportCaseV1CaseHistory[] }> = ({ data }) => (
    <Table columns={columns} dataSource={data ?? []} rowKey={(record: any) => record.id} pagination={false} scroll={{ y: 500 }} rowHoverable={false} />
  );
  const handleDownloadJSONClick = () => {
    const anchor = document.createElement('a');
    anchor.href = `data:text/json;charset=utf-8,${encodeURIComponent(JSON.stringify(removeTypename(props?.data), null, 2))}`;
    anchor.download = 'case-history.json';
    anchor.click();
    setModalVisible(false);
  };

  function removeTypename(obj: any): any {
    if (Array.isArray(obj)) {
      return obj.map(removeTypename);
    } else if (obj && typeof obj === 'object') {
      const { __typename, ...rest } = obj;
      return Object.fromEntries(Object.entries(rest).map(([key, value]) => [key, removeTypename(value)]));
    }
    return obj;
  }

  return (
    <>
      <Helmet>
        <title>{props?.isCaseOrApplicant} - History</title>
      </Helmet>
      <Card
        hoverable
        style={{
          width: '100%',
          height: '100%',
          marginTop: 20
        }}
      >
        <HistoryTable data={sortedLogs} />
        <br />
        <Modal title="Case History Details" open={modalVisible} footer={null} onCancel={() => setModalVisible(false)}>
          <pre>
            <JsonView data={removeTypename(data)} shouldExpandNode={allExpanded} />
          </pre>
          <Button type="primary" onClick={() => handleDownloadJSONClick()}>
            Download
          </Button>
        </Modal>
      </Card>
    </>
  );
};
